import { IHttpResponse } from 'angular';
import { IUploadFileResult } from '../../core/interfaces/upload-file-response.interface';

export class UploadingFile {
  progress: number;
  error: IHttpResponse<any> = null;
  result: IUploadFileResult = null;

  constructor( public file: File ) {
  }

  updateProgress( value: number ) {
    this.progress = Math.floor(value);
  }
}



// WEBPACK FOOTER //
// ./app/components/attachment-upload-btn/uploading-file.ts